import { render } from "./BusinessGroupParametersForm.vue?vue&type=template&id=0df74521&scoped=true"
import script from "./BusinessGroupParametersForm.vue?vue&type=script&lang=js"
export * from "./BusinessGroupParametersForm.vue?vue&type=script&lang=js"

import "./BusinessGroupParametersForm.vue?vue&type=style&index=0&id=0df74521&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df74521"]])

export default __exports__